<template>
  <v-dialog @input="$emit('value', $event)"
            :value="value"
            max-width="500px"
            scrollable>
    <v-card>
      <v-card-title>
        {{$t('general.notifications')}}
      </v-card-title>

      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12">
            {{$t('general.notificationPermissions')}}
          </v-col>

          <v-col cols="12">
            <v-img src="https://storage.googleapis.com/keybe/app/images/notificaciones.png?v=2"></v-img>
          </v-col>

          <v-col>
            <v-checkbox hide-details
                        :label="$t('general.dontShowMessage')"
                        v-model="hideNotificationsAlert">
            </v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn block
               @click="$emit('input', false)"
               color="kbGreen"
               dark>
          {{$t('general.accept')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    hideNotificationsAlert: {
      get () {
        return this.$store.state.auth.hideNotificationsAlert
      },
      set (value) {
        this.$store.commit('SET_HIDE_NOTIFICATIONS_ALERT', value)
      }
    }
  },
  props: ['value']
}
</script>
